"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _shopeeOrder = require("@/api/shopeeOrder.api");
var _enum = require("@/utils/enum");
var _OrderModal = _interopRequireDefault(require("../order/components/OrderModal.vue"));
var _GiveAwayModal = _interopRequireDefault(require("../give-away/components/GiveAwayModal.vue"));
var _giveaway = require("@/types/giveaway");
var ProductPage = /*#__PURE__*/function (_Vue) {
  function ProductPage() {
    var _this;
    (0, _classCallCheck2.default)(this, ProductPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ProductPage, [].concat(args));
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "listLoading", false);
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 12,
      search: null
    });
    (0, _defineProperty2.default)(_this, "tagOptions", _enum.tagOptions);
    (0, _defineProperty2.default)(_this, "GiveawayType", _giveaway.GiveawayType);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    return _this;
  }
  (0, _inherits2.default)(ProductPage, _Vue);
  return (0, _createClass2.default)(ProductPage, [{
    key: "getProductImage",
    value: function getProductImage(row) {
      var parseListImage = !!row.images ? JSON.parse(row.images) : [];
      return parseListImage === null || parseListImage === void 0 ? void 0 : parseListImage[0];
    }
  }, {
    key: "handleLink",
    value: function () {
      var _handleLink = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(row) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.$refs.modal.handleLink(row, "shopee");
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleLink(_x) {
        return _handleLink.apply(this, arguments);
      }
      return handleLink;
    }()
  }, {
    key: "handleLinkGift",
    value: function handleLinkGift(row) {
      this.$refs.giftModal.handleLink(row, "shopee");
    }
  }, {
    key: "handleShowOrder",
    value: function handleShowOrder(row) {
      var routeData = this.$router.resolve({
        path: "/order/index",
        query: {
          orderCode: row.order.code
        }
      });
      window.open(routeData.href, "_blank");
    }
  }, {
    key: "handleShowGift",
    value: function handleShowGift(row) {
      var routeData = this.$router.resolve({
        path: "/gift/index",
        query: {
          orderCode: row.giveaway.code
        }
      });
      window.open(routeData.href, "_blank");
    }
  }, {
    key: "handleSync",
    value: function () {
      var _handleSync = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              this.listLoading = true;
              _context2.next = 4;
              return _shopeeOrder.shopeeOrderApi.sync();
            case 4:
              this.fetchData();
            case 5:
              _context2.prev = 5;
              this.listLoading = false;
              return _context2.finish(5);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0,, 5, 8]]);
      }));
      function handleSync() {
        return _handleSync.apply(this, arguments);
      }
      return handleSync;
    }()
  }, {
    key: "created",
    value: function created() {
      this.fetchData();
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this2 = this;
      this.listLoading = true;
      _shopeeOrder.shopeeOrderApi.findAll(this.query).then(function (res) {
        _this2.data = res.data.shopeeOrders.map(function (e) {
          e.customerInfo = !!e.recipientAddress ? JSON.parse(e.recipientAddress) : {};
          return e;
        });
        _this2.total = res.data.total;
      }).finally(function () {
        return _this2.listLoading = false;
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
ProductPage = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    Pagination: _index.default,
    OrderModal: _OrderModal.default,
    GiveAwayModal: _GiveAwayModal.default
  }
})], ProductPage);
var _default = exports.default = ProductPage;